import { v4 as uuid } from 'uuid';
import { isPcPlatform } from './auth';
import { getServerGid } from './native';

/**
 * 从埋点 Web SDK 中取 DeviceId 当做 gid, 每 100 毫秒取一次直到取到为止
 */
export const getGid: () => Promise<string> = () => {
    return new Promise((resolve) => {
        try {
            resolve(window.mtstat?.getStatsMarker());
        } catch (error) {
            console.log('getGid error===', error);
            resolve('');
        }
    });
};

let cacheGid = '';
let loop = 3;
let timer: NodeJS.Timeout | null | undefined = null;

const getGidList: Function[] = [];

/**
 * 循环取 gid, 如果三次没取到就随机生成(可能遇到埋点 Web SDK 初始化失败)
 *
 * @returns 返回 gid
 */
export const waitUntilGetGid = async (timerCall?: NodeJS.Timeout | null | undefined): Promise<string> => {
    // console.log('====>waitUntilGetGid');
    if (timerCall) {
        clearTimeout(timerCall);
        timer = null;
    }
    return new Promise((resolve) => {
        if (cacheGid) {
            if (getGidList.length) {
                for (let i = 0; i < getGidList.length; i++) {
                    const rs = getGidList[i];
                    rs(cacheGid);
                    // console.log('====>resolve waitUntilGetGid');
                }
                getGidList.length = 0;
            }
            return resolve(cacheGid);
        } else {
            getGidList.push(resolve);
            if (!timer && loop) {
                timer = setTimeout(async () => {
                    loop--;
                    waitUntilGetGid(timer);
                }, loop * 500);
            }

            let gid = '';

            // 循环次数耗尽获取失败, 随机生成一个
            if (!loop) {
                gid = uuid();
                cacheGid = gid;
                waitUntilGetGid(timer);
            } else {
                (isPcPlatform() ? getServerGid() : getGid()).then((res: string) => {
                    gid = res;
                    if (gid) {
                        cacheGid = gid;
                        waitUntilGetGid(timer);
                    }
                });
            }
        }
    });
};
